export enum MenuName {
    Estimate = 'estimate',
    Job = 'job',
    Client = 'client',
    Contact = 'contact',
}
